import {Component, OnInit, ViewChild} from '@angular/core';
import {BaseView} from "../../../../../core/view/base.view";
import {IDialogComponent} from "../../../../../common/dialog/iDialog.component";
import {DialogWithInput} from "../../../../../common/dialog/dialogWithInput";
import {CommonModule} from "@angular/common";
import {DialogModule} from "../../../../../common/dialog/dialog.module";
import {FormFieldModule} from "../../../../../core/component/form-field/form-field.module";
import {RichTextEditorModule} from "../../../../../../components/common/rich-text-editor/rich-text-editor.module";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {FormModule} from "../../../../../form/form.module";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {RephraseTextService} from "../../service/rephraseText.service";
import {
    TranscriptionConfig
} from "../../../../../common/audio/transcription/api/component/audio-transcription/audio-transcription.component";
import {RichTextEditorComponent} from "../../../../../../components/common/rich-text-editor/rich-text-editor.component";
import {
    AudioTranscriptionConfig, AudioTranscriptionHandler
} from "../../../../../common/audio/transcription/api/component/audio-transcription-v2/audio-transcription-v2.component";

export interface RephraseDialogInput {
    text?: string;
    role: string;
    audioTranscriptionHandler?: AudioTranscriptionHandler<any>;
}

export interface RephraseDialogResult {
  rephrasedText: string;
}

@Component({
  templateUrl: './rephrase-dialog.component.html',
  standalone: true,
    imports: [
        CommonModule,
        DialogModule,
        FormFieldModule,
        FormModule,
        ReactiveFormsModule,
        RichTextEditorModule,
        ButtonModule,
    ],
    providers: [
        RephraseTextService
    ]
})
export class RephraseDialogComponent extends BaseView implements
    IDialogComponent<RephraseDialogInput, RephraseDialogResult>, OnInit {
  dialog: DialogWithInput<RephraseDialogInput, RephraseDialogResult>;

  @ViewChild('editor') editor: RichTextEditorComponent;

  audioTranscriptionConfig: AudioTranscriptionConfig;
  formGroup: FormGroup;
  loading = false;

  constructor(private formBuilder: FormBuilder,
              private rephraseTextService: RephraseTextService) {
    super();
    this.formGroup = this.formBuilder.group({
        text: new FormControl(undefined, Validators.required)
    });
  }

  ngOnInit() {
    if (this.dialog.input.text) {
      this.formGroup.patchValue({
        text: this.dialog.input.text
      });
    }
      this.audioTranscriptionConfig = {
          context: 'none',
          audioContentValue: 'AUDIO_CONTENT_TEXT_REPHRASE',
          startAutomatically: false,
          enableConversationOption: false,
          handler: this.dialog.input.audioTranscriptionHandler,
          showPreview: true,
      }
  }

  rephrase() {
        this.loading = true;
        this.editor.stopTranscription();
        this.rephraseTextService.execute({
            text: this.formGroup.get('text').value,
            role: this.dialog.input.role,
            options: {
                temperature: 0.7
            }
        })
            .toPromise()
            .then(result => {
                this.dialog.close({
                    rephrasedText: result.text
                });
            })
            .catch(e => {
                this.toastControl.presentError(e);
            })
            .finally(() => {
                this.loading = false;
            });
  }
}
